import React from 'react';
import { AppBar, UserMenu, translate } from 'react-admin';
import SettingsIcon from '../icon/IcnSetting';
import UserIcon from '../icon/IcnProfile';
import HelpIcon from '../icon/IcnHelp';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { withStyles, createStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withRouter } from 'react-router';
import compose from 'recompose/compose';

const styles = theme => createStyles({
    title: {
        flex: 1,
        marginLeft: '0.2em'
    },
});

const CustomUserMenu = translate(({ translate, ...props }) => (
    <UserMenu icon={<UserIcon />} {...props} label={translate('user.title')}>
        <List>
            <ListItem>
                <ListItemText primary={localStorage.getItem('name')} secondary={localStorage.getItem('email')}/>
            </ListItem>
        </List>          
    </UserMenu>  
));

const ConfigButton = translate(({ translate, history, ...props }) => (
    <Tooltip title={translate('config.title')}>
          <IconButton color="inherit" onClick={() => history.push(props.path)}>
              <SettingsIcon />
          </IconButton>
      </Tooltip>
));

const HelpButton = translate(({ translate, history, ...props }) => (
    <Tooltip title={translate('help.title')}>
        <IconButton color="inherit" onClick={() => history.push(props.path)}>
            <HelpIcon />
        </IconButton>
    </Tooltip>
));

const CustomAppBar = ({ translate, classes, ...props }) => (
    <AppBar userMenu={<CustomUserMenu />} {...props} color="primary">
        <Typography variant="title" color="inherit" className={classes.title} id="react-admin-title" />
        <HelpButton path='/help' {...props} />
        <ConfigButton path='/config' {...props} />
    </AppBar>
);

const enhance = compose(
    translate,
    withRouter,
    withStyles(styles)
);

export default enhance(CustomAppBar);
